import React from "react";
import PropTypes from "prop-types";

export default function Arrow(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.4712L1 5.52733L13.985 5.52733L9.68183 1.66741L10.4259 1L16 6L10.4259 11L9.68183 10.3326L13.9866 6.4712L1 6.4712Z"
        fill={props.fill}
        stroke={props.stroke}
      />
    </svg>
  );
}
Arrow.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};
Arrow.defaultProps = {
  className: "",
  fill: "#ffffff",
  stroke: "#ffffff",
  width: 17,
  height: 12,
  onClick: () => null
};
